<template>
	<div
		class="border-s border-white rounded-circle overflow-hidden d-flex align-center justify-center"
		:style="size"
		@click="$emit('click')"
	>
		<Cover v-if="src" :width="width" :height="height" :src="src" />
		<AvatarDefault v-else :style="size" class="avatar__rounded" />
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import Cover from './Cover.vue'
	import AvatarDefault from './dafaults/AvatarDefault.vue'

	interface Props {
		src?: string
		height?: string
		width?: string
	}

	const props = withDefaults(defineProps<Props>(), {
		src: undefined,
		height: '100%',
		width: '100%',
	})

	defineEmits(['click'])

	const size = computed(() => {
		return {
			height: props.height,
			width: props.width,
		}
	})
</script>
